import { CLIPBOARD_SCORE } from "@src/appV2/ClipboardScore/constants";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";
import { differenceInMilliseconds, hoursToMilliseconds, isAfter } from "date-fns";

interface ShiftBottomSheetUrgentShiftCardProps {
  startDate: Date;
  discardLatenessBooktimeThresholdInHours: number;
}

export function ShiftBottomSheetUrgentShiftCard(props: ShiftBottomSheetUrgentShiftCardProps) {
  const { startDate, discardLatenessBooktimeThresholdInHours } = props;

  const now = new Date();
  const isInProgress = isAfter(now, startDate);
  const isWithinThreshold =
    differenceInMilliseconds(startDate, now) <=
    hoursToMilliseconds(discardLatenessBooktimeThresholdInHours);

  if (!isWithinThreshold && !isInProgress) {
    return null;
  }

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="warning"
      title={
        isInProgress
          ? "This is an urgent shift. Please leave as soon as possible."
          : "This is an urgent shift"
      }
      description={`Your arrival time will not affect your ${CLIPBOARD_SCORE} unless you no-show.`}
      illustrationType="hours-limit"
    />
  );
}
